import { Modal } from "@mui/material";
import { t } from "i18next";
import Image from "next/image";
// import { subscribeNewsLetter, subscribeNewsletter } from "@/api/traveler";
import Close from "@/assets/images/icons/close.svg";
import CustomButton from "@/common/customElements/button";
import HexagonButton from "@/common/customElements/HexagonButton";
import { AbsoluteDiv } from "@/common/divs";
import { CustomInput, CustomSelect } from "@/common/inputs";
import { AlmostBoldNewLineText, RegularText } from "@/common/texts";
import GoogleTranslationComponent from "@/components/googleTranslate/GoogleTranslationComponent";
import { ModalProps } from "@/types/components";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const ModalForm: React.FC<ModalProps> = ({ open, setOpen }) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className="centerModal"
        style={{ height: "auto", maxHeight: "90vh" }}
      >
        <AbsoluteDiv right="24px" top="24px" style={{ zIndex: "9" }}>
          <HexagonButton
            onClick={() => {
              setOpen(false);
            }}
            width="32px"
            backgroundColor={PRIMARY_BUTTON_COLOR}
          >
            <Image
              alt="icon"
              width="16"
              height="16"
              src={Close.src}
              style={{
                position: "absolute",
                top: "20%",
                left: "27%",
              }}
            />
          </HexagonButton>
        </AbsoluteDiv>

        <form
          action="https://vee.us11.list-manage.com/subscribe/post?u=902e0348b001acfc7d745099c&id=30fe4388f1&f_id=001bd0e3f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
        >
          <AlmostBoldNewLineText
            style={{ marginLeft: "20px", marginRight: "20px" }}
            fontSize="20px"
          >
            <GoogleTranslationComponent text="¡Suscríbete a la newsletter y obtén un 10% de descuento!" />
          </AlmostBoldNewLineText>

          <CustomInput
            type="text"
            name="FNAME"
            id="mce-FNAME"
            defaultValue=""
            required
            style={{ height: "50px" }}
            className="inputNewsletterEmail"
            placeholder={t("register.info.name")}
            width="100%"
            height="50px"
            marginY="16px"
          />

          <CustomInput
            type="email"
            name="EMAIL"
            id="mce-EMAIL"
            required
            defaultValue=""
            style={{ height: "50px" }}
            className="inputNewsletterEmail"
            placeholder={t("register.info.email_label")}
            width="100%"
            height="50px"
            marginY="16px"
          />

          <CustomSelect
            style={{
              height: "50px",
              width: "100%",
              marginTop: "16px",
              marginBottom: "16px",
            }}
            name="CIUDAD"
            className="required"
            id="mce-CIUDAD"
          >
            <option value="" disabled selected>
              {" "}
              {t("activity.fiscal_data_form.city")}
            </option>
            <option value="Barcelona">Barcelona</option>
            <option value="Madrid">Madrid</option>
            <option value="Sevilla">Sevilla</option>
            <option value="Málaga">Málaga</option>
            <option value="Granada">Granada</option>
            <option value="Mallorca">Mallorca</option>
            <option value="Córdoba">Córdoba</option>
            <option value="Valencia">Valencia</option>
            <option value="San Sebastián">San Sebastián</option>
            <option value="Bilbao">Bilbao</option>
            <option value="Alicante">Alicante</option>
            <option value="Toledo">Toledo</option>
            <option value="Valladolid">Valladolid</option>
            <option value="Burgos">Burgos</option>
            <option value="Salamanca">Salamanca</option>
            <option value="León">León</option>
            <option value="Palencia">Palencia</option>
            <option value="Zamora">Zamora</option>
            <option value="Segovia">Segovia</option>
            <option value="Soria">Soria</option>
            <option value="Ceuta">Ceuta</option>
            <option value="Melilla">Melilla</option>
            <option value="Badajoz">Badajoz</option>
            <option value="Cáceres">Cáceres</option>
            <option value="Mérida">Mérida</option>
            <option value="Pontevedra">Pontevedra</option>
            <option value="A Coruña">A Coruña</option>
            <option value="Ourense">Ourense</option>
            <option value="Lugo">Lugo</option>
            <option value="Santiago de Compostela">
              Santiago de Compostela
            </option>
            <option value="Vigo">Vigo</option>
            <option value="Murcia">Murcia</option>
            <option value="Castellón de la Plana">Castellón de la Plana</option>
            <option value="Peñíscola">Peñíscola</option>
            <option value="Benidorm">Benidorm</option>
            <option value="Cádiz">Cádiz</option>
            <option value="Almería">Almería</option>
            <option value="Huelva">Huelva</option>
            <option value="Jaén">Jaén</option>
            <option value="Ronda">Ronda</option>
            <option value="Zaragoza">Zaragoza</option>
            <option value="Huesca">Huesca</option>
            <option value="Teruel">Teruel</option>
            <option value="Las Palmas">Las Palmas</option>
            <option value="Santa Cruz de Tenerife">
              Santa Cruz de Tenerife
            </option>
            <option value="Lanzarote">Lanzarote</option>
            <option value="Fuerteventura">Fuerteventura</option>
            <option value="Santa Cruz de la Palma">
              Santa Cruz de la Palma
            </option>
            <option value="Albacete">Albacete</option>
            <option value="Toledo">Toledo</option>
            <option value="Ciudad Real">Ciudad Real</option>
            <option value="Cuenca">Cuenca</option>
            <option value="Tarragona">Tarragona</option>
            <option value="Lleida">Lleida</option>
            <option value="Girona">Girona</option>
            <option value="Deltebre">Deltebre</option>
            <option value="Puigcerdà">Puigcerdà</option>
            <option value="Begur">Begur</option>
            <option value="Tortosa">Tortosa</option>
            <option value="Menorca">Menorca</option>
            <option value="Ibiza">Ibiza</option>
            <option value="Formentera">Formentera</option>
            <option value="Logroño">Logroño</option>
            <option value="Navarra">Navarra</option>
            <option value="Vitoria">Vitoria</option>
            <option value="Oviedo">Oviedo</option>
            <option value="Santander">Santander</option>
          </CustomSelect>

          <div id="mce-responses" className="clear">
            <div
              className="response"
              id="mce-error-response"
              style={{ display: "none" }}
            />
            <div
              className="response"
              id="mce-success-response"
              style={{ display: "none" }}
            />
          </div>
          <div
            aria-hidden="true"
            style={{ position: "absolute", left: "-5000px" }}
          >
            <input
              type="text"
              name="b_902e0348b001acfc7d745099c_30fe4388f1"
              tabIndex={-1}
              defaultValue=""
            />
          </div>
          <div aria-hidden="true">
            <input type="hidden" name="tags" value="10281371" />
          </div>
          <div>
            <button
              type="submit"
              name="subscribe"
              id="mc-embedded-subscribe"
              className="button"
              defaultValue="Subscribe"
            >
              <CustomButton
                toBeResponsive={true}
                width="350px"
                height="50px"
                marginY="16px"
                marginLeft="16px"
                backgroundColor={PRIMARY_BUTTON_COLOR}
                // onClick={() => {
                //   subscribeNewsletter();
                //   subscribeNewsLetter();
                // }}
              >
                <RegularText fontSize="18px" color={NEUTRO_TITLES_COLOR}>
                  {t("footer.suscribe_button")}
                </RegularText>
              </CustomButton>
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ModalForm;
